<template>
    <div class="fixed" id="fixed">
        <div class="headerContent">
            <div class="logo">
                <img src="@/assets/logo.png" />
            </div>
            <!-- start el-menu -->
            <el-menu
                :default-active="activeIndex"
                class="menuList"
                mode="horizontal"
                @select="handleMenuSelect"
                text-color="#fff"
                active-text-color="#fff"
            >
                <template v-for="(item, index) in menuList">
                    <el-menu-item
                        v-if="!item.children.length"
                        :index="(index + 1).toString()"
                        :key="index"
                        @click="toPage(item.link)"
                    >{{ item.name }}</el-menu-item>
                    <el-submenu v-else :index="(index + 1).toString()" :key="index">
                        <template slot="title">{{ item.name }}</template>
                        <template v-for="(childItem, childIndex) in item.children">
                            <el-menu-item
                                v-if="childItem.children.length == 0"
                                :key="childIndex"
                                :index="(index + 1) + '-' + (childIndex + 1)"
                                @click="toPage(childItem.link, childIndex)"
                            >
                                <span class="subMenuColor">{{ childItem.name }}</span>
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <div class="switchButton">
                    <button class="button" @click="switchLang">{{ $store.state.currentLang }}</button>
                    <!-- <button class="button"  @click="switchLang" :class="[switchNum%2==0?'enClass':'zhClass']">{{$store.state.currentLang}}</button> -->
                </div>
            </el-menu>
            <!-- end el-menu -->
            <!-- start switchButton -->
            <!-- <div class="switchButton"> -->
            <!-- <button class="button" @click="switchLang">{{ $store.state.currentLang }}</button> -->
            <!-- <button class="button"  @click="switchLang" :class="[switchNum%2==0?'enClass':'zhClass']">{{$store.state.currentLang}}</button> -->
            <!-- </div> -->
            <!-- end switchButton -->
        </div>
    </div>
</template>
<script>
export default {
    name: "headerPage",
    data() {
        return {
            activeIndex: '1',//当前下标
            menuList: [],//菜单列表
            switchNum: 0,//切换语言点击次数
            scrollX: 0,//x轴偏移量
        }
    },
    methods: {
        // 缓存语言，加载菜单
        getMenu(language) {
            // 更改语言
            this.$i18n.locale = language === 'Cn' ? 'zh-CN' : 'en-US'
            // 加载菜单
            this.menuList = this.$t('translateObj.menuList')
            // 修改vuex
            this.$store.commit('switchLang', language)
            // 更改缓存
            localStorage.setItem('language', language)
        },
        //点击导航栏  
        handleMenuSelect(key, keyPath) {
            // console.log(key, keyPath);
            this.activeIndex = keyPath[keyPath.length - 1] + ''
            // 缓存当前菜单激活项
            localStorage.setItem('menuIndex', this.activeIndex)
        },
        //切换语言
        switchLang() {
            // this.switchNum++;
            let language = this.$store.state.currentLang === 'Cn' ? 'En' : 'Cn'
            console.log(language)
            this.getMenu(language)
        },
        //跳转页面
        toPage(link, index) {
            let params = {}
            if (link == 'recruit' || link == 'marketing' || link == 'newsList' || link == 'culture' || 'technology') {
                params = { index }
            }
            this.$router.push({ name: link, query: params })
            localStorage.removeItem('tabIndex')
        }
    },
    created() {
        // 获取缓存语言
        let language = localStorage.getItem('language') ? localStorage.getItem('language') : 'Cn'
        this.getMenu(language)
        window.onscroll = function () {
            let sl = -Math.max(document.body.scrollLeft, document.documentElement.scrollLeft);
            document.getElementById('fixed').style.left = sl + 'px';
            this.scrollX = parseInt(-sl) + 'px'
            let scrollWidth = document.body.scrollWidth
            document.getElementById('fixed').style.width = scrollWidth + 'px'
        }
    },
    mounted() {
        //菜单页面path
        const onePages = new Map([
            ['1','/'],
            ['2','/productList'],
            ['3','/marketing'],
            ['4','/culture'],
            ['5','/technology'],
            ['6','/systemGuarantee'],
            ['7','/newsList'],
            ['8','/recruit']
        ])
        let  pageIndex = localStorage.getItem('menuIndex') || '1',
        path = ''
        // 显示显示激活项
        this.activeIndex = pageIndex
        // 首页、产品除外
        if(!['1','2'].includes(pageIndex)){
            let index = pageIndex.slice(2)-1 // 子菜单激活项
            pageIndex = pageIndex.slice(0,1) // 路由
            path = `${onePages.get(pageIndex)}?index=${index}`
        }else{
             path = onePages.get(pageIndex)
        }
        this.$router.push(path)
    },
    beforeDestroy() {
        localStorage.removeItem('menuIndex')
        localStorage.removeItem('language')
    },
    watch: {
        "$store.state.currentLang": {
            immediate: false,
            handler(newVal, oldVal) {
                this.menuList = this.$t('translateObj.menuList')
            }
        },
        "$store.state.headerIndex"(newVal, oldVal) {
            // console.log('activeIndex', newVal)
            this.activeIndex = newVal
        }
    }
}

</script>

<style lang="less">
@import "../style/index";
.fixed {
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 999;
    background: #00a0a9;
}
.headerContent {
    position: relative;
    display: flex;
    align-items: center;
    min-width: 1500px;
    .logo {
        margin-left: 40px;
        img {
            .imgStyle(211px, 36px);
        }
    }
    .menuList {
        // background: linear-gradient(to right, rgb(0, 110, 255) 28px, rgb(125, 201, 231) 50%, rgb(86, 96, 189));
        .flexStyle(end, end);
        flex-wrap: nowrap;
        background: #00a0a9;
        // background: rgba(0,160,169,0.4);
        position: relative;
        width: calc(100% - 200px);
        min-width: 900px;
        padding: 0px 160px 0px 40px;
        white-space: nowrap;
        .el-menu-item,
        .el-submenu__title {
            height: 75px !important;
            line-height: 75px !important;
            margin: 0px 10px;
        }
        .el-submenu__title i {
            color: #fff;
        }
        .el-menu-item:hover,
        .el-submenu:hover .el-submenu__title,
        .el-menu-item:focus,
        .el-submenu:focus .el-submenu__title {
            background: none !important;
        }
    }
    .switchButton {
        .verticalPosition(calc(100% - 114px));
        .button {
            width: 54px;
            height: 25px;
            border-radius: 16px;
            border: none;
            background: #a1d0e5;
            cursor: pointer;
            .fontStyle(14px, #fff, bold);
        }
        .enClass {
            //    background: #A1D0E5 !important;
        }
        .zhClass {
            // background: #ccc !important;
        }
    }
}
.subMenuColor {
    color: #333 !important;
}
.el-menu.el-menu--horizontal {
    border: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue